import request from '@/services/base/request';
import ServicesEnum from '@/services/_helpers/_types';
export default {
    login: () => request(ServicesEnum.screener, '/auth/token/', 'get', null),
    getApiKey: () => request(ServicesEnum.screener, '/user/public-api-key/', 'get', null),
    getSign: (params) => request(ServicesEnum.screener, '/binance/sign/', 'get', null, { params }),
    access: (params) => request(ServicesEnum.screener, '/user/access/', 'get', null, { params })
};
